import {
    MultiFormatClipboard,
    type MultiFormatClipboardContent,
} from '../../../capacitor_plugins/multiFormatClipboard';

/**
 * Writes every supplied representation to one native clipboard item.
 */
export const writeContentToNativeClipboard = async (content: MultiFormatClipboardContent): Promise<void> => {
    await MultiFormatClipboard.write(content);
};

export const writeToNativeClipboard = async (clipboardText: string): Promise<void> => {
    await writeContentToNativeClipboard({ plainText: clipboardText });
};

/**
 * Reads every supported representation from the first native clipboard item.
 */
export const readContentFromNativeClipboard = async (): Promise<MultiFormatClipboardContent> => {
    return MultiFormatClipboard.read();
};

export const readFromNativeClipboard = async (): Promise<string> => {
    const { plainText } = await readContentFromNativeClipboard();
    return plainText;
};
